/** This function creates options used in the custom Select component based on resources passed through it.
 * Returns an array of objects containing value and text properties. The value is based on the title of the resource component retrieved
 * from Contentful.
 */

const createSelectOptionsByResource = resources => {
  const parsedResources = [];
  const options = [];
  Object.entries(resources).forEach(([key, value]) => parsedResources.push({ key, value }));
  parsedResources.map(resource =>
    options.push({
      value: resource.key,
      text: resource.value.text,
    })
  );

  return options;
};

export default createSelectOptionsByResource;
